<template>
  <div class="preview-modal-content">
    <h3 class="preview-modal__title">{{ $t('EMAIL_TEMPLATES.PREVIEW_TITLE') }}</h3>
    <div class="preview-modal__section">
      <label class="preview-modal__label">{{ $t('EMAIL_TEMPLATES.SUBJECT_LABEL') }}</label>
      <p class="preview-modal__subject">{{ subject }}</p>
    </div>
    <div class="preview-modal__section">
      <label class="preview-modal__label">{{ $t('EMAIL_TEMPLATES.BODY_LABEL') }}</label>
      <div class="preview-modal__body" v-dompurify-html="bodyHtml" />
    </div>
    <div v-if="attachments.length" class="preview-modal__section">
      <label class="preview-modal__label">{{ $t('EMAIL_TEMPLATES.EDITOR.ATTACHMENTS_LABEL') }}</label>
      <ul class="preview-modal__attachments">
        <li
          v-for="(att, attIdx) in attachments"
          :key="att.id || `att-${attIdx}-${att.filename}`"
          class="preview-modal__attachment-row"
        >
          <fluent-icon icon="document" size="16" class="text-slate-500 shrink-0" />
          <a
            v-if="att.url"
            :href="att.url"
            target="_blank"
            rel="noopener"
            class="preview-modal__attachment-link"
          >
            {{ att.filename }}
          </a>
          <span v-else class="preview-modal__attachment-name">{{ att.filename }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailTemplatePreviewContent',
  props: {
    subject: {
      type: String,
      default: '',
    },
    bodyHtml: {
      type: String,
      default: '',
    },
    attachments: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-modal-content {
  padding: var(--space-large);
  max-height: 80vh;
  overflow: auto;
}

.preview-modal__title {
  margin: 0 0 var(--space-normal);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-bold);
  color: var(--color-heading);
}

.preview-modal__section {
  margin-bottom: var(--space-normal);
}

.preview-modal__label {
  display: block;
  font-size: var(--font-size-mini);
  font-weight: var(--font-weight-medium);
  color: var(--color-body);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: var(--space-micro);
}

.preview-modal__subject {
  margin: 0;
  padding: var(--space-small) var(--space-normal);
  background-color: var(--color-background);
  border-radius: var(--border-radius-small);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  color: var(--color-heading);
}

.preview-modal__body {
  margin-top: var(--space-small);
  padding: var(--space-normal);
  border-radius: var(--border-radius-small);
  border: 1px solid var(--color-border);
  background-color: var(--color-background);
  font-size: var(--font-size-small);
}

.preview-modal__attachments {
  list-style: none;
  margin: var(--space-small) 0 0;
  padding: 0;
}

.preview-modal__attachment-row {
  display: flex;
  align-items: center;
  gap: var(--space-small);
  padding: var(--space-micro) 0;
}

.preview-modal__attachment-link {
  font-size: var(--font-size-small);
  color: var(--w-500);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.preview-modal__attachment-name {
  font-size: var(--font-size-small);
  color: var(--color-heading);
}
</style>
